import { render } from "./ManageAccess.vue?vue&type=template&id=54719b16&scoped=true"
import script from "./ManageAccess.vue?vue&type=script&lang=js"
export * from "./ManageAccess.vue?vue&type=script&lang=js"

import "./ManageAccess.vue?vue&type=style&index=0&id=54719b16&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54719b16"]])

export default __exports__